/**
url 相关工具类
ver 1.0.0
修改记录：
  2018-6-12：
    urlUitls.getRequestParamter
*/
let urlUitls = {}

/**
    获取请求url锚点之后的参数
    @method getRequestAnchorParamter
    @param

    @return {object} 参数键值对
*/
urlUitls.getRequestAnchorParamter = function () {
  let url = window.location.href.substring(window.location.href.indexOf('#/') + 1)
  return this.getRequestParamter(url)
}
/**
        获取请求url后面的参数。
        @method getRequestParamter
        @param

        @return {object} 参数键值对
    */
urlUitls.getRequestParamter = function (urlStr, symbol = '#') {
  // var url = location.search; //获取url中"?"符后的字串
  var url = ''
  if (urlStr) {
    url = urlStr
  } else {
    url = window.location.href //获取url中"?"符后的字串
  }
  url = url.substr(url.indexOf('?'))

  var theRequest = new Object()
  if (url.indexOf('?') != -1) {
    let str = url.substr(1)
    let strs = str.split('&')
    for (let i = 0; i < strs.length; i++) {
      var tmp = strs[i].split('=') //a=b#123
      var tmpValue = tmp[1]
      if (tmpValue && tmpValue.indexOf('#') && symbol == '#') {
        tmpValue = tmpValue.split('#')[0]
      }

      theRequest[tmp[0]] = tmpValue

      //  theRequest[strs[i].split("=")[0]] = unescape(strs[i].split("=")[1]);
    }
  }
  return theRequest
}

urlUitls.paramSerializer = function (params) {
  //  console.log("urlUitls.params",params);
  if (!params) return
  var parts = []
  var keys = Object.keys(params)
  if (keys.length <= 0) return
  for (var i = 0; i < keys.length; i++) {
    let tmp = keys[i]
    var value = params[tmp]
    //if (!value) continue;
    if (_valueType.isArray(value)) {
      value.forEach(function (v) {
        parts.push(
          urlUitls.encodeUriQuery(keys[i]) + '=' + urlUitls.encodeUriQuery(_serializeValue(v))
        )
      })
    } else {
      parts.push(
        urlUitls.encodeUriQuery(keys[i]) + '=' + urlUitls.encodeUriQuery(_serializeValue(value))
      )
    }
  }
  return parts.join('&')
}

/**
    获取url的全路径用于，window.open新开状况
    @method getFullUrl
    @param url 相对、全路径，根路径
    @return url 全路径

  var url="http://www.w3school.com.cn/tiy/t.asp?f=jseg_string";=》
  var url="/tiy/t.asp?f=jseg_string";=》http://www.w3school.com.cn/tiy/t.asp?f=jseg_string
  var url="tiy/t.asp?f=jseg_string"; =》http://www.w3school.com.cn/tiy/tiy/t.asp?f=jseg_string
*/
urlUitls.getFullUrl = function (url) {
  if (url.indexOf('http://') > -1 || url.indexOf('https://') > -1) {
    return url
  }
  if (url.indexOf('/') == 0) {
    return window.location.protocol + '//' + window.location.host + url
  } else {
    var temp = window.location.protocol + '//' + window.location.host + window.location.pathname
    return temp.substring(0, temp.lastIndexOf('/')) + '/' + url
  }
}

//获取当前的url
urlUitls.getLocationUrl = function (path) {
  if (path.indexOf('http://') > -1 || path.indexOf('https://') > -1) {
    return path
  } else {
    return window.location.origin + window.location.pathname + path
  }
}

urlUitls.encodeUriQuery = function (val, pctEncodeSpaces) {
  return encodeURIComponent(val)
    .replace(/%40/gi, '@')
    .replace(/%3A/gi, ':')
    .replace(/%24/g, '$')
    .replace(/%2C/gi, ',')
    .replace(/%3B/gi, ';')
    .replace(/%20/g, pctEncodeSpaces ? '%20' : '+')
}

//获取当前域名
/**
  @method getDomain
  @param url 相对、全路径，根路径(/content/index.html#/dict/table/edit)
  @return url 全路径(http://sccdev.cd.pangu16.com/content/index.html#/dict/table/edit)
  prefix 只在url中没有http或者https并且prefix有值时才会当做前缀加在url前面
*/
urlUitls.getDomain = function (url, prefix) {
  if (url && url.indexOf('http://') == -1 && url.indexOf('https://') == -1) {
    if (prefix) {
      return prefix + url
    }
    return window.location.protocol + '//' + window.location.host + url
  }
  return url
}

//将参数拼接在url后面，将参数值为数组转为多个参数（如：date:['2018-5-2','2018-6-9'] 转为url?date0=2018-5-2&date1=2018-6-9）
/**
  @method 
  @param url 地址
  @return pram 参数对象
*/
urlUitls.setRequestParamter = function (url, pram) {
  if (!url || !pram) return url
  for (let key in pram) {
    let temp = pram[key]
    if (Array.isArray(temp) && temp.length > 0 && typeof temp[0] == 'string') {
      for (let i = 0; i < temp.length; i++) {
        url += url.indexOf('?') > -1 ? '&' : '?'
        url += key + i + '=' + temp[i]
      }
    } else if (typeof temp === 'object' && !(temp instanceof Function) && temp !== null) {
      // 支持将复杂对象拼接到url上(用于打印按钮paramters参数)
      Object.keys(temp).forEach((k) => {
        url += url.indexOf('?') > -1 ? '&' : '?'
        url += `${key}_${k}=${temp[k]}`
      })
    } else {
      url += url.indexOf('?') > -1 ? '&' : '?'
      url += key + '=' + temp
    }
  }
  return url
}
/**
 * 获取静态资源路径
 * @example
 * src: 'https://cdn.jsdelivr.net/npm/pdfjs-dist@2.0.943/build/pdf.worker.min.js'
   src: '/static/pdf/2.0.943/build/pdf.worker.js'
   src: 'https://cdn.jsdelivr.net/npm/pdfjs-dist@2.6.347/build/pdf.worker.min.js'
   src: '/static/pdf/2.6.347/build/pdf.worker.min.js'
   或者
   cMapUrl: 'https://cdn.jsdelivr.net/npm/pdfjs-dist@2.0.943/cmaps/',
   cMapUrl: '/static/pdf/2.0.943/cmaps/',
   cMapUrl: 'https://cdn.jsdelivr.net/npm/pdfjs-dist@2.6.347/cmaps/',
   cMapUrl: '/static/pdf/2.6.347/cmaps/'
 * 
 * @param {String} src 
 * @returns 
 */
urlUitls.getSrc = function (src) {
  const url = window.location.href

  if (/\/link\//.test(url)) return '/link' + src
  if (/\/union\//.test(url)) return '/union' + src
  if (/\/extreme_host\//.test(url)) return '/extreme_host' + src

  return src
}

export default urlUitls

/*****************************内部方法以及变量************************************/
let _valueType = {
  isUndefined(value) {
    return typeof value === 'undefined'
  },
  isNumber(value) {
    return typeof value === 'number'
  },
  isObject(value) {
    return value !== null && typeof value === 'object'
  },
  isDate(value) {
    return toString.call(value) === '[object Date]'
  },
  isArray(value) {
    return Array.isArray(value)
  },
}

function _serializeValue(v) {
  if (v === null || typeof v == 'undefined') return ''

  if (_valueType.isObject(v)) {
    return _valueType.isDate(v) ? v.toISOString() : toJson(v)
  }
  return v
}

// function _isObjectEmpty(obj) {
//     if (obj) {
//         for (var prop in obj) {
//             if (obj.hasOwnProperty(prop)) {
//                 return false
//             }
//         }
//     }
//     return true
// }

function toJson(obj, pretty) {
  if (_valueType.isUndefined(obj)) return undefined
  if (!_valueType.isNumber(pretty)) {
    pretty = pretty ? 2 : null
  }
  return JSON.stringify(obj, pretty)
}
